import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-62d0ff79"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "online_gift_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1));

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关联产品", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, [/*#__PURE__*/_createTextVNode("产品设置"), /*#__PURE__*/_createElementVNode("b")])], -1));

const _hoisted_8 = {
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import GiftBasicForm from "@com/marketing/GiftBasicForm.vue";
import ProductSettings from "@com/marketing/GiftProductSettings.vue";
import { ref, reactive } from "vue";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import api from "@api/gift";
import useRoute from "@util/router";
export default {
  __name: 'GiftDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "综合活动详情";
    var modifyMode = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "综合活动详情";
        getData();
      },
      add: () => {
        title = "新增综合活动";
      },
      modify: () => {
        modifyMode = true;
        title = "修改综合活动";
        getData();
      }
    });
    const activeName = ref("basic");
    const giftBasicFormRef = ref(null);

    function tabChange(active) {
      giftBasicFormRef.value.getValue();

      if (active == 'spec') {
        giftBasicFormRef.value.check().then(valid => {
          if (valid) {
            activeName.value = active;
          }
        });
      } else {
        activeName.value = active;
      }
    }

    const productSettings = ref(null);
    const productSettingsData = ref([]);
    const programme = ref([]);
    const data = ref({});

    function getData() {
      api.details(urlQuery.code, val => {
        data.value = val;

        if (val.payType) {
          data.value.payTypeList = val.payType.split(',');
        }

        productSettingsData.value = val.giftPoolList;
      });
    }

    function save(submitType) {
      giftBasicFormRef.value.check().then(valid => {
        if (valid) {
          let paramsData = giftBasicFormRef.value.getValue();
          paramsData.giftType = '1011001';
          paramsData.submitType = submitType;

          if ($.isNotEmpty(paramsData.payTypeList)) {
            paramsData.payType = paramsData.payTypeList.join(',');
          }

          productSettings.value.getValue().then(res => {
            if (res) {
              paramsData.giftPoolList = res;
              $.handleCRU(urlQuery.type, {
                add: () => {
                  api.add(paramsData, () => {
                    $msg.succ("保存成功");
                    route.go(-1);
                  });
                },
                modify: () => {
                  paramsData.giftCode = urlQuery.code;
                  api.update(paramsData, () => {
                    $msg.succ("保存成功");
                    route.go(-1);
                  });
                }
              });
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: "basic"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(GiftBasicForm, {
                ref_key: "giftBasicFormRef",
                ref: giftBasicFormRef,
                readOnly: _unref(readOnly),
                data: data.value
              }, null, 8, ["readOnly", "data"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "spec"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              })]),
              default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(ProductSettings, {
                ref_key: "productSettings",
                ref: productSettings,
                data: productSettingsData.value,
                travelProgramme: programme.value,
                readOnly: _unref(readOnly),
                modify: _unref(modifyMode)
              }, null, 8, ["data", "travelProgramme", "readOnly", "modify"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = $event => tabChange('spec')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = $event => tabChange('basic'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[4] || (_cache[4] = $event => save(0)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'spec']]) : _createCommentVNode("", true), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[5] || (_cache[5] = $event => save(1)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存并上架 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'spec']]) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};